<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill="currentColor"
      d="M23.998 18.684a18.67 18.67 0 0 1-5.298-.762 26.667 26.667 0 0 1-1.583 1.519 20.574 20.574 0 0 0 6.881 1.176v-1.933ZM24 22.095c-2.897 0-5.664-.557-8.198-1.57-.59.454-1.198.883-1.826 1.286A23.908 23.908 0 0 0 24 23.998v-1.904.001ZM24 15.33c-.998 0-1.974-.095-2.918-.277a25.85 25.85 0 0 1-1.293 1.661c1.347.34 2.758.519 4.21.519v-1.904.001ZM23.998 0h-1.902c0 5.211-1.806 10-4.823 13.778a22.25 22.25 0 0 1-7.1 5.84A21.997 21.997 0 0 1 0 22.098V24c4.371 0 8.47-1.169 12-3.21l.282-.168.175-.104c.159-.096.315-.194.47-.294.045-.028.088-.057.132-.086.113-.073.225-.146.337-.222l.185-.127c.08-.056.163-.11.243-.168a24.156 24.156 0 0 0 4.307-3.895l.063-.074c.101-.118.202-.236.3-.355l.127-.155c.072-.088.145-.177.216-.268l.139-.177.127-.163H19.1A23.894 23.894 0 0 0 24 .003V0Z"
    />
    <path
      fill="currentColor"
      d="M8.015 15.257a17.284 17.284 0 0 0 5.275-4.288A17.161 17.161 0 0 0 17.23 0h-1.903c0 3.606-1.246 6.922-3.33 9.54A15.266 15.266 0 0 1 8.667 0H6.763c0 4.167 1.48 7.988 3.942 10.969a15.36 15.36 0 0 1-3.983 2.81A22.005 22.005 0 0 1 1.902 0H-.001v.011a23.901 23.901 0 0 0 4.898 14.52c-1.538.519-3.185.8-4.898.8v1.904a17.186 17.186 0 0 0 8.017-1.976v-.002Z"
    />
  </svg>
</template>
